module.exports = __webpack_public_path__ + "static/low-loader-2-13fefb29536035193600778c4b49c725.jpg";